import { Button, Stack, Typography } from '@mui/material';
import { styled } from '@mui/system';

const Form = styled('form')({});

const Title = styled(Typography)({});

Title.defaultProps = {
  variant: 'h3',
};

const Description = styled(Typography)({});

Description.defaultProps = {
  variant: 'body1',
  color: 'text.muted',
};

const Container = styled(Stack)(({ theme }) => ({
  flexShrink: 0,
  padding: theme.spacing(5),
  borderTop: `1px dashed ${theme.palette.border.default}`,
  borderBottom: `1px dashed ${theme.palette.border.default}`,
  borderImage: `repeating-linear-gradient(90deg,${theme.palette.border.default} 0,${theme.palette.border.default} 4px,transparent 0,transparent 8px) 1`,
  width: '100%',
  flexDirection: 'column',
  justifyContent: 'start',
  alignItems: 'start',
  gap: theme.spacing(3),
}));

const Header = styled(Stack)(({ theme }) => ({
  flexDirection: 'column',
  justifyContent: 'start',
  alignItems: 'start',
  gap: theme.spacing(2),
}));

const Body = styled(Stack)(({ theme }) => ({
  width: '100%',
  flexDirection: 'column',
  justifyContent: 'start',
  alignItems: 'start',
  gap: theme.spacing(3),
}));

const NextButton = styled(Button)({});

NextButton.defaultProps = {
  variant: 'contained',
  type: 'submit',
  color: 'primary',
};

export { Form, Title, Description, Container, Header, Body, NextButton };
